import React from "react";
import SettingsComponent from "./SettingsComponent";

const SettingsContainer = () => {
  return <SettingsComponent />;
};

export default SettingsContainer;
